const containerCls = "_086c92na33";
const inputCls = "_086i1l1tauh";
const formulaEditorCls = "_086fz39g09";
const placeholderIconCls = "_086pp6698x";

export { containerCls, formulaEditorCls, inputCls, placeholderIconCls };
import "./RichTextInput.style.linaria.module.css";
//# sourceMappingURL=RichTextInput.style.js.map
